import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=c6337b60&scoped=true"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6337b60",
  null
  
)

export default component.exports